/* import __COLOCATED_TEMPLATE__ from './phone-handover-hang-up-form.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type {
  HangUpConfiguration,
  ScheduledConfigurationKey,
} from 'embercom/models/fin-voice/number-configuration';

interface Args {
  form: any;
  configType: ScheduledConfigurationKey;
  handoverConfig?: HangUpConfiguration;
  refreshConfig: () => void;
}

export default class PhoneHandoverHangUpForm extends Component<Args> {
  @service declare intl: IntlService;

  get goodbyeMessage() {
    return this.args.handoverConfig?.config.goodbyeMessage;
  }

  set goodbyeMessage(value: string | undefined) {
    if (!this.args.handoverConfig) {
      return;
    }

    if (!this.args.handoverConfig.config) {
      this.args.handoverConfig.config = {};
    }

    this.args.handoverConfig.config.goodbyeMessage = value;
    this.args.refreshConfig();
  }

  get hasValidGoodbyeMessage() {
    return this.goodbyeMessage && this.goodbyeMessage.trim().length > 0;
  }

  @action
  updateGoodbyeMessage(value: string) {
    this.goodbyeMessage = value;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::NumberConfiguration::PhoneHandover::PhoneHandoverHangUpForm': typeof PhoneHandoverHangUpForm;
  }
}
